import Async from "./Async"
import Loader from "./Loader"
import React from "react"
import Grid from "semantic-ui-react/dist/es/collections/Grid/Grid"
import Button from "semantic-ui-react/dist/es/elements/Button/Button"
import Modal from "semantic-ui-react/dist/es/modules/Modal/Modal"

class AsyncModal extends React.Component {
  render = () => {
    const { resolve } = this.props
    return (
      <Async
        resolve={resolve}
        pending={<Loader text="Please wait..." />}
        fulfilled={htmlText => (
          <Modal
            defaultOpen={true}
            style={{ minHeight: "20em" }}
            onClose={this.props.onCancel}
            closeOnDimmerClick={false}
            className="scrolling"
            onMount={() => {
              setTimeout(() => {
                ;["dimmable", "dimmed", "scrolling"].forEach(className => {
                  document
                    .getElementsByTagName("body")[0]
                    .classList.add(className)
                })
              }, 0)
            }}
            onUnmount={() => {
              ;["dimmable", "dimmed", "scrolling"].forEach(className => {
                document
                  .getElementsByTagName("body")[0]
                  .classList.remove(className)
              })
            }}
          >
            <Modal.Content>
              <Grid className="white">
                <Grid.Row>
                  <Grid.Column className="Agreement">
                    <div dangerouslySetInnerHTML={{ __html: htmlText }} />
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row style={{ borderTop: "1px solid #ccc" }}>
                  <Grid.Column
                    textAlign="right"
                    style={{ paddingRight: "2em" }}
                  >
                    <Button
                      onClick={this.props.onCancel}
                      content="Ok"
                      primary
                      type="button"
                    />
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Modal.Content>
          </Modal>
        )}
      />
    )
  }
}

export default AsyncModal
